import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons';

import { Dropdown, Menu, Modal } from 'antd';
import { getIdFromUID } from '../../lib/utils';
import { deleteReview } from '../../actions';
import { spacing, fixedSpacing, colors } from '../../lib/theme';

const { confirm } = Modal;

class ReviewOptions extends Component {

    deleteReviewFn(uid, guid, collectionId) {
        const { deleteReview } = this.props;
        confirm({
            title: 'Are you sure you want to delete this review?',
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                //   console.log('OK');
                deleteReview(uid, guid, collectionId);
            },
            onCancel() {
                //   console.log('Cancel');
            },
        });
    }


    render() {
        const { userDetails, review } = this.props;
        const user = review.user;
        const currentUserUID = userDetails && userDetails.uid && getIdFromUID(userDetails.uid);

        const menu = (
            <Menu>
                {(user.id == currentUserUID) && <Menu.Item key="deleteReview">
                    <a onClick={this.deleteReviewFn.bind(this, userDetails.uid, review.episode && review.episode.guid, review.episode && review.episode.collectionId)}>
                        <DeleteOutlined style={{ color: 'red' }} /> Delete Review</a></Menu.Item>}
            </Menu>
        );

        return (
            <div>
                {
                    userDetails && <Dropdown overlay={menu} trigger={['click']}>
                        <a className="ant-dropdown-link" href="#">
                            {/* Add to playlist <Icon type="down" /> */}
                            {/* <FontAwesomeIcon icon='ellipsis-v' /> */}
                            <EllipsisOutlined style={{ fontSize: `${fixedSpacing('md')}`, color: `${colors.primary}` }} />
                        </a>
                    </Dropdown>
                }
            </div>
        );
    }
}

ReviewOptions.propTypes = {
    userDetails: PropTypes.object,
    review: PropTypes.object.isRequired,
    deleteReview: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteReview: bindActionCreators(deleteReview, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewOptions)